import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'templates'
const verb = HttpMethod.POST

export default class OspreyTemplatesShareToAffiliations extends BaseAction {
    constructor(dataKey) {
        const id = 'da005367-e266-4138-9d40-535805241262'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToAffiliations(params) {
        const { templateId, affiliationIdList } = params

        this.path = `/${resource}/${templateId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-affiliations-share.js